import React from "react";
import "./style.css";
import Aos from "aos";
import "aos/dist/aos.css";
import handleViewport from "react-in-viewport";

class About extends React.Component {
  componentDidMount() {
    Aos.init({ duration: 500, once: true });
  }

  render() {
    return (
      <div className="about" id="about">
        <div className="about-items">
          <div className="about-header">
            <div data-aos="fade-in" className="about-heading">
              <div>About&nbsp; </div>{" "}
              <span style={{ color: "rgb(255, 65, 31)" }}>me</span>
            </div>
          </div>
          <div data-aos="fade-in" className="about-body">
            <p>
              Hi, I am Sagar. I am a react developer based in Gurugram, Haryana.
              Currently, I am pursuing my graduation in Computer Science from
              Amity University. I have deep interest in learning new
              technologies and techniques out there. While working on React
              projects, my highest priority is the speed, responsiveness,
              intuitiveness and dynamic nature of websites.
              <br /> Apart from it, I love doing Yoga. It has become a part of
              my life.
            </p>
          </div>
        </div>
      </div>
    );
  }
}
//Using Viewport
const MySection2 = handleViewport(About, { rootMargin: "-50%" });

export default MySection2;
